import React from "react";

const QuoteBlock = ({ text }) => {
  return (
    <div className="relative my-20 md-max:my-0 mx-16 md-max:mx-[2rem] bg-[#F1F7FF]/80 flex justify-center items-center">
      {/* Left gradient border */}
      <div className="absolute left-0 top-0 h-full w-1 z-10">
        <div className="h-full w-full bg-gradient-to-b from-[#3573F9]/10 via-[#3573F9] to-[#3573F9]/10 rounded-l-lg" />
      </div>
      {/* Right gradient border */}
      <div className="absolute right-0 top-0 h-full w-1 z-10">
        <div className="h-full w-full bg-gradient-to-b from-[#3573F9]/10 via-[#3573F9] to-[#3573F9]/10 rounded-r-lg" />
      </div>
      {/* background image */}
      <img
        src="/perspective-grid.png"
        alt="QuoteBlock"
        className="h-40 object-contain"
      />
      {/* text */}
      <p className="text-xl absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[56rem] md-max:w-[90%] md-max:text-sm">
        {text}
      </p>
    </div>
  );
};

export default QuoteBlock;
